import Amount from "@/models/Shared/Amount";

export default class ThirdPartyAccount {
    id: string;
    name: string;
    iban: string;
    sortCode: string;
    accountNumber: string;
    balance: Amount = new Amount();
}